module.exports = __webpack_public_path__ + "img/dots(2).ca6066d0.svg";